import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStatamicComponent } from './simple-icons-statamic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStatamicComponent ],
    exports:      [ SimpleIconsStatamicComponent ],
    bootstrap:    []
})
export class SimpleIconsStatamicModule {}
